export default "__VITE_ASSET__92968993__"